import { getNames, registerLocale } from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import ru from 'i18n-iso-countries/langs/ru.json';
import type { LocaleName } from '@stores/locale';

registerLocale(en);
registerLocale(ru);

export const getCountryOptions = (locale: LocaleName) => {
  const language = locale === 'ru_RU' ? 'ru' : 'en';

  return Object.entries(getNames(language))
    .sort(([, first], [, second]) => first.localeCompare(second, language))
    .map(([code, name]) => ({ value: code, label: `${name} (${code})` }));
};
